import { render, staticRenderFns } from "./ConfigurationSubmitOrder.vue?vue&type=template&id=20d8779f&scoped=true"
import script from "./ConfigurationSubmitOrder.vue?vue&type=script&lang=js"
export * from "./ConfigurationSubmitOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8779f",
  null
  
)

export default component.exports